<template>
  <section>
    <h1 class="section-head">กลุ่มผู้ใช้งาน</h1>
    <router-link class="button is-success is-pulled-right" :to="'/group/add/'" v-can="'add_group'"><i class="fas fa-plus"></i>เพิ่ม</router-link>
    <b-table
      :data="groups"
      selectable @click="selected"
      :selected.sync="selectedItem"
      :hoverable="true"
      :loading="isTableLoading">

      <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="ชื่อกลุ่มผู้ใช้งาน">
              {{ props.row.description }}
          </b-table-column>

        </template>
    </b-table>
    <div class="notification has-text-centered" v-if="groups.length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
  </section>
</template>

<script>
  import UserModel from '@/model/user_model'

  export default {
    name: 'Group_index',
    data() {
      return {
        groups: [],
        selectedItem: {},
        lastSelected: {},
        isTableLoading: true
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      async init(){
        this.groups = await UserModel.get_groups();
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("edit_group|add_group")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/group/edit/'+item.id })
        }
        this.lastSelected = item;
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Group/index.vue